var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeadsGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8555 2.36929C16.7591 2.14667 16.5993 1.95737 16.396 1.82501C16.1927 1.69265 15.955 1.6231 15.7124 1.62504H2.28809C2.04593 1.62504 1.80897 1.69539 1.60603 1.82753C1.40309 1.95967 1.2429 2.14792 1.14494 2.36939C1.04697 2.59086 1.01544 2.83601 1.05419 3.07506C1.09293 3.31411 1.20028 3.53676 1.36318 3.71595L6.50025 9.36666V15.4572C6.50009 15.6835 6.5614 15.9056 6.67763 16.0998C6.79386 16.294 6.96064 16.453 7.16018 16.5597C7.35971 16.6665 7.5845 16.7171 7.81054 16.7061C8.03658 16.6951 8.25539 16.6229 8.4436 16.4972L10.9436 14.8307C11.115 14.7167 11.2555 14.5621 11.3526 14.3806C11.4498 14.1991 11.5005 13.9964 11.5002 13.7906V9.36674L16.6373 3.71588C16.802 3.53767 16.9104 3.31492 16.9492 3.07544C16.988 2.83596 16.9554 2.59036 16.8555 2.36929Z",
    stroke: "#00D998",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadsGreen);
export default __webpack_public_path__ + "static/media/leads-green.07f1571323545e0a6bdc2f1328715030.svg";
export { ForwardRef as ReactComponent };